import styled from 'styled-components';

const CollectionStyle = styled.div`
	--colContPaddingBottom: var(--sectionDistance);
	--colHeaderPaddingV: 0;
	--colTextWidth: 74.218vw;
	--colTextPaddingTop: var(--sp4x);
	--colTextMarginBottom: var(--sp16x);
	--colProductMarginBottom: var(--sp5x);

	.collection-header {
		background-color: var(--bodyColor);
		display: flex;
		align-items: center;
		justify-content: space-between;
		text-align: center;
		padding: var(--colHeaderPaddingV) 0;
		z-index: 2;

		.collection-title {
			width: 100%;
			opacity: 0;
		}
	}

	.collection-body {
		overflow: hidden;

		.collection-text {
			width: var(--colTextWidth);
			margin: 0 auto var(--colTextMarginBottom);
			padding-top: var(--colTextPaddingTop);
			opacity: 0;
			text-align: center;
		}

		.explore-btn-wrap {
			margin: 0 auto var(--colTextMarginBottom);
			text-align: center;
		}

		.collection-products-row {
			margin-bottom: calc(-1 * var(--colProductMarginBottom));

			.collection-product-cont {
				margin-bottom: var(--colProductMarginBottom);
				opacity: 0;
			}
		}
	}

	&:not(:last-child) {
		.collection-body .collection-products-row {
			padding-bottom: var(--colContPaddingBottom);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--colTextWidth: 73.958vw;
		--colTextPaddingTop: var(--sp3x);
		--colTextMarginBottom: var(--sp13x);
		--colProductMarginBottom: var(--sp5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--colTextWidth: 73.509vw;
		--colTextPaddingTop: var(--sp3x);
		--colTextMarginBottom: var(--sp10x);
		--colProductMarginBottom: var(--sp5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--colTextWidth: 75.555vw;
		--colTextPaddingTop: var(--sp3x);
		--colTextMarginBottom: var(--sp9x);
		--colProductMarginBottom: var(--sp4x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--colTextWidth: 75.625vw;
		--colTextPaddingTop: var(--sp3x);
		--colTextMarginBottom: var(--sp8x);
		--colProductMarginBottom: var(--sp4x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--colTextWidth: 75vw;
		--colTextPaddingTop: var(--sp3x);
		--colTextMarginBottom: var(--sp7x);
		--colProductMarginBottom: var(--sp4x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--colTextWidth: 100%;
		--colTextPaddingTop: var(--sp3x);
		--colTextMarginBottom: var(--sp7x);
		--colProductMarginBottom: var(--sp3x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--colContPaddingBottom: var(--sp5x);
		--colHeaderPaddingV: var(--sp2x);
		--colTextWidth: 100%;
		--colTextPaddingTop: var(--sp5x);
		--colTextMarginBottom: var(--sp4x);
		--colProductMarginBottom: var(--sp2-5x);

		--colIconSize: var(--sp4x);

		.collection-header {
			position: sticky;
			top: 0;
			border-top: 1px solid var(--primaryColor9);
			border-bottom: 1px solid transparent;
			transition: all 0.1 var(--trTime);

			.collection-title {
				width: calc(100% - var(--colIconSize) - var(--sp2x));
				text-align: left;
			}

			.collection-plus-cont {
				position: relative;
				width: var(--colIconSize);
				min-width: var(--colIconSize);
				height: var(--colIconSize);
				border: 1px solid var(--primaryColor9);
				border-radius: 50%;
				backface-visibility: hidden;

				&::before,
				&::after {
					content: '';
					position: absolute;
					width: calc(var(--colIconSize) / 2);
					height: 1px;
					top: 50%;
					left: 50%;
					background-color: var(--primaryColor9);
					backface-visibility: hidden;
					transition: transform var(--trTime);
				}

				&:before {
					transform: translate3d(-50%, -50%, 0);
				}

				&:after {
					transform: translate3d(-50%, -50%, 0) rotate(90deg);
				}
			}
		}

		&.active {
			.collection-header {
				border-bottom: 1px solid var(--primaryColor9);

				.collection-plus-cont {
					&:after {
						transform: translate3d(-50%, -50%, 0) rotate(0deg);
					}
				}
			}
		}

		&:last-child {
			border-bottom: 1px solid var(--primaryColor9);
		}

		.collection-body .collection-products-row {
			padding-bottom: var(--colContPaddingBottom);
		}
	}
`;

export default CollectionStyle;
